import { render, staticRenderFns } from "./BidsAddBulkPricingTableActionColumn.vue?vue&type=template&id=ecdea8cc"
import script from "./BidsAddBulkPricingTableActionColumn.vue?vue&type=script&lang=js"
export * from "./BidsAddBulkPricingTableActionColumn.vue?vue&type=script&lang=js"
import style0 from "./BidsAddBulkPricingTableActionColumn.vue?vue&type=style&index=0&id=ecdea8cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports